import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Linkedin, Award, BookOpen, Clock } from 'lucide-react';
import { mockData } from '../data/mock';

const Team = () => {
  const ceo = mockData.team.find(member => member.position.includes('CEO'));
  const otherMembers = mockData.team.filter(member => !member.position.includes('CEO'));
const mail="mailto:"+ceo.email;
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-primary to-primary-dark pt-28" style={{ paddingTop: '6.5rem' }}>
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="hero-text mb-6">Meet Our Team</h1>
            <p className="text-xl text-gray-800 leading-relaxed">
              The talented individuals behind NS7VISUALS success passionate professionals dedicated to bringing your vision to life.
            </p>
          </div>
        </div>
      </section>

      {/* CEO Spotlight */}
      {ceo && (
        <section className="section-padding bg-white">
          <div className="container">
            <div className="text-center mb-16">
              <h2 className="section-header mb-4">Leadership</h2>
              <p className="text-xl text-gray-700 max-w-2xl mx-auto">
                Meet our visionary leader who guides NS7VISUALS towards excellence and innovation
              </p>
            </div>
            
            <div className="max-w-6xl mx-auto">
              <div className="card-white overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                  <div className="order-2 lg:order-1">
                    <div className="space-y-6">
                      <div>
                        <h3 className="text-3xl font-bold text-black mb-2">{ceo.name}</h3>
                        <p className="text-xl text-gray-600 mb-4">{ceo.position}</p>
                        <p className="text-gray-700 leading-relaxed text-lg">{ceo.bio}</p>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-4">
                          <div className="flex items-center space-x-3">
                            <BookOpen size={20} className="text-gray-600" />
                            <div>
                              <div className="font-semibold text-sm text-gray-900">Education</div>
                              <div className="text-gray-600 text-sm">{ceo.education}</div>
                            </div>
                          </div>
                          
                          <div className="flex items-center space-x-3">
                            <Clock size={20} className="text-gray-600" />
                            <div>
                              <div className="font-semibold text-sm text-gray-900">Experience</div>
                              <div className="text-gray-600 text-sm">{ceo.experience}</div>
                            </div>
                          </div>
                          
                          {ceo.email && (
                            <div className="flex items-center space-x-3">
                              <Mail size={20} className="text-gray-600" />
                              <div>
                                <div className="font-semibold text-sm text-gray-900">Email</div>
                                <div className="text-gray-600 text-sm"><a href={mail} className="hover:text-blue-400 transition-colors">{ceo.email}</a></div>
                              </div>
                            </div>
                          )}
                        </div>
                        
                        <div>
                          <div className="font-semibold text-sm text-gray-900 mb-3">Areas of Expertise</div>
                          <div className="flex flex-wrap gap-2">
                            {ceo.expertise.map((skill, index) => (
                              <span 
                                key={index}
                                className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium"
                              >
                                {skill}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="order-1 lg:order-2">
                    <div className="relative">
                      <img 
                        src={ceo.image} 
                        alt={ceo.name}
                        className="w-full max-w-md mx-auto rounded-2xl shadow-2xl"
                      />
                      <div className="absolute -bottom-6 -right-6 bg-black text-white p-4 rounded-xl">
                        <div className="text-2xl font-bold">{ceo.experience}</div>
                        <div className="text-xs opacity-80">Leading Teams</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Team Members Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="section-header mb-4">Our Creative Team</h2>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              Each team member brings unique skills and perspective to every project
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
  {otherMembers.map((member, index) => (
    <div 
      key={index} 
      className="card-white group text-center p-6 flex flex-col items-center"
    >
      {/* Image Section */}
      <div className="relative w-full flex justify-center mb-6">
        <img 
          src={member.image} 
          alt={member.name}
          className="w-full h-64 md:h-72 lg:h-80 rounded-2xl object-cover group-hover:scale-105 transition-transform duration-300 shadow-md"
        />
        <div className="absolute bottom-3 right-3 bg-black text-white p-2 rounded-full shadow-lg">
          <Award size={18} />
        </div>
      </div>

      {/* Text Section */}
      <div className="space-y-3 flex-1 flex flex-col justify-center">
        <h3 className="font-semibold text-2xl mb-1">{member.name}</h3>
        <p className="text-gray-600 mb-2">{member.position}</p>
        <p className="text-gray-700 text-sm leading-relaxed px-2">{member.bio}</p>
      </div>
    </div>
  ))}
</div>

        </div>
      </section>
            {/* <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3 text-xs">
                <div>
                  <div className="font-semibold text-gray-900">Education</div>
                  <div className="text-gray-600">{member.education}</div>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Experience</div>
                  <div className="text-gray-600">{member.experience}</div>
                </div>
              </div>
              
              <div>
                <div className="font-semibold text-sm text-gray-900 mb-2">Skills</div>
                <div className="flex flex-wrap gap-1 justify-center">
                  {member.expertise.map((skill, skillIndex) => (
                    <span 
                      key={skillIndex}
                      className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div> */}

      {/* Team Culture */}
      <section className="section-padding bg-gray-50">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="section-header mb-4">Our Culture</h2>
              <p className="text-xl text-gray-700">
                What makes NS7VISUALS a great place to work and collaborate
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  title: 'Collaboration',
                  description: 'We believe the best ideas come from working together, sharing perspectives, and building on each other\'s strengths.',
                  icon: '🤝'
                },
                {
                  title: 'Innovation',
                  description: 'We encourage creative thinking, experimentation, and staying ahead of design trends and technologies.',
                  icon: '💡'
                },
                {
                  title: 'Growth',
                  description: 'We invest in our team\'s professional development and provide opportunities to learn and advance careers.',
                  icon: '🌱'
                }
              ].map((culture, index) => (
                <div key={index} className="card-white text-center">
                  <div className="text-4xl mb-4">{culture.icon}</div>
                  <h3 className="font-semibold text-lg mb-3">{culture.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{culture.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Join Our Team */}
      <section className="section-padding bg-white">
        <div className="container text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="section-header mb-4">Want to Join Our Team?</h2>
            <p className="text-xl text-gray-700 mb-8">
              We're always looking for talented individuals who share our passion for great design and client success
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn-primary">
                Get In Touch <ArrowRight size={20} />
              </Link>
              <Link to="/about" className="btn-secondary">
                Learn About Our Culture
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
            <section className="section-padding bg-black text-white">
              <div className="container text-center">
                <h2 className="section-headers mb-4 text-white">Ready to Get Started?</h2>
                <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                  Let's discuss your project and explore how we can help bring your vision to life
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/contact" className="bg-white text-black px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                    Start Your Project
                  </Link>
                  <Link to="/portfolio" className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-colors">
                    View Our Work
                  </Link>
                </div>
              </div>
            </section>
    </div>
  );
};

export default Team;